import { Locale } from '@synergy/models';
import { createSelector } from 'reselect';
import { getLocalizedString } from '@synergy/utils';

import { AppState } from '../../store/store';
import { CategoriesState } from './categories-reducer';
import { Category } from '../models/category';
import { CategoryDto } from '../models/dto/category-dto';
import { localesSelector } from './configuration-selectors';

export const categoriesState = (state: AppState): CategoriesState => state.categories;

const mapCategory = (locales: Locale[], category: CategoryDto): Category => {
    return {
        id: category.id,
        name: getLocalizedString(locales, category.translations),
        parentId: category.parentId,
        hasChildren: category.hasChildren ?? false,
        count: category.count ?? 0,
    };
};

export const categoriesSelector = createSelector(
    [localesSelector, categoriesState],
    (locales, state) => (parentId?: number) => {
        return state.categoriesByParentId[parentId ?? -1]?.map(c => mapCategory(locales, c)) ?? [];
    }
);
